<template>
  <div class="major-project-tab">
    <!-- Query Area -->
    <el-form :model="query" ref="queryForm" label-position="left" label-width="150px" class="mp-query" @keyup.enter.native="handleSearch">
      <el-row>
        <el-col :xl="6" :lg="8" :md="12">
          <el-form-item label="Project Name">
            <el-input clearable size="small" v-model="query.projectName" placeholder="Please input"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xl="6" :lg="8" :md="12">
          <el-form-item label="Project Level">
            <el-select clearable size="small" v-model="query.projectLevel" placeholder="Please select" style="width:100%">
              <el-option v-for="l in projectLevelOptions" :key="l.labelKey" :label="l.labelValue" :value="l.labelKey"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="6" :lg="8" :md="12">
          <el-form-item label="Project Status">
            <el-select clearable size="small" v-model="query.projectStatus" placeholder="Please select" style="width:100%">
              <el-option v-for="s in projectStatusOptions" :key="s.labelKey" :label="s.labelValue" :value="s.labelKey"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="6" :lg="8" :md="12">
          <el-form-item label="Labour Hour">
            <div class="mp-range-pair">
              <el-input clearable size="small" v-model="query.labourHourMin" placeholder="Min" style="width:calc(50% - 12px)"></el-input>
              <span class="mp-range-sep">—</span>
              <el-input clearable size="small" v-model="query.labourHourMax" placeholder="Max" style="width:calc(50% - 12px)"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :xl="6" :lg="8" :md="12">
          <el-form-item label="Order Labour Hour">
            <div class="mp-range-pair">
              <el-input clearable size="small" v-model="query.orderLabourHourMin" placeholder="Min" style="width:calc(50% - 12px)"></el-input>
              <span class="mp-range-sep">—</span>
              <el-input clearable size="small" v-model="query.orderLabourHourMax" placeholder="Max" style="width:calc(50% - 12px)"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :xl="6" :lg="8" :md="12">
          <el-form-item label="Mgmt Labour Hour">
            <div class="mp-range-pair">
              <el-input clearable size="small" v-model="query.mgmtLabourHourMin" placeholder="Min" style="width:calc(50% - 12px)"></el-input>
              <span class="mp-range-sep">—</span>
              <el-input clearable size="small" v-model="query.mgmtLabourHourMax" placeholder="Max" style="width:calc(50% - 12px)"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <!-- Actions -->
        <el-col :xl="12" :lg="24" :md="24" class="mp-btn-col">
          <el-button type="primary" size="small" @click="handleSearch">Search</el-button>
          <el-button size="small" @click="handleReset">Reset</el-button>
          <el-button size="small" :loading="exportLoading" @click="handleExport">Export</el-button>
        </el-col>
      </el-row>
    </el-form>

    <!-- Table -->
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      size="small"
      border
      style="width:100%"
      :header-cell-style="{background:'#F5F5F9'}"
      @sort-change="handleSortChange"
    >
      <el-table-column prop="projectName" label="Project Name" min-width="200" sortable="custom" align="left" fixed="left" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <a style="color:blue;cursor:pointer;" @click="openDetail(scope.row)">{{ scope.row.projectName }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="projectLevelDesc" label="Project Level" width="180" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="projectStatusDesc" label="Project Status" width="140" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="labourHour" label="Labour Hour" width="130" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="orderLabourHour" label="Order Labour Hour" width="170" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="mgmtLabourHour" label="Mgmt Labour Hour" width="175" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="remark" label="Remark(Major Project)" min-width="200" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="Modify" width="110" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleModify(scope.row)">Modify</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Pagination -->
    <div class="mp-pagination">
      <span class="mp-pagination-total">Total {{ total }}</span>
      <el-pagination
        small
        layout="prev, pager, next, sizes"
        :total="total"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size.sync="pageSize"
        @current-change="onPageChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- Modify Remark Modal -->
    <el-dialog title="Modify Remark" :visible.sync="modifyVisible" width="480px">
      <el-form label-position="left" label-width="70px">
        <el-form-item label="Remark:">
          <el-input type="textarea" :rows="4" v-model="modifyRemark" placeholder="Please input remark" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="modifyVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="modifySaving" @click="saveModify" style="margin-left: 6px">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MajorProjectTab',
  props: {
    accountInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // Query
      query: {
        projectName: '',
        projectLevel: '',
        projectStatus: '',
        labourHourMin: '',
        labourHourMax: '',
        orderLabourHourMin: '',
        orderLabourHourMax: '',
        mgmtLabourHourMin: '',
        mgmtLabourHourMax: '',
      },
      projectLevelOptions: [],
      projectStatusOptions: [],
      // Table
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      sortField: '',
      sortOrder: '',
      tableLoading: false,
      // Export
      exportLoading: false,
      // Modify modal
      modifyVisible: false,
      modifyRow: null,
      modifyRemark: '',
      modifySaving: false,
    }
  },
  watch: {
    'accountInfo.id'(val) {
      if (val) {
        this.loadData()
      }
    }
  },
  created() {
    this.initDropdownData()
    if (this.accountInfo.id) {
      this.loadData()
    }
  },
  methods: {
    initDropdownData() {
      let url = `${this.$store.state.islhurl}configMain/queryLabelList?`
      const configKeyList = ['majorProjectLevel', 'projectStatus']
      let str = ''
      configKeyList.forEach(item => { str += `&configKeyList=${item}` })
      url = url + str.substring(1)
      this._post(url).then(res => {
        if (res.data && res.code === 200) {
          this.projectLevelOptions = res.data.majorProjectLevel || []
          this.projectStatusOptions = res.data.projectStatus || []
        }
      }).catch(() => {})
    },
    buildQueryParams() {
      const params = {}
      if (this.query.projectName) params.projectName = this.query.projectName
      if (this.query.projectLevel) params.projectLevel = this.query.projectLevel
      if (this.query.projectStatus) params.projectStatus = this.query.projectStatus
      if (this.query.labourHourMin) params.labourHourMin = this.query.labourHourMin
      if (this.query.labourHourMax) params.labourHourMax = this.query.labourHourMax
      if (this.query.orderLabourHourMin) params.orderLabourHourMin = this.query.orderLabourHourMin
      if (this.query.orderLabourHourMax) params.orderLabourHourMax = this.query.orderLabourHourMax
      if (this.query.mgmtLabourHourMin) params.mgmtLabourHourMin = this.query.mgmtLabourHourMin
      if (this.query.mgmtLabourHourMax) params.mgmtLabourHourMax = this.query.mgmtLabourHourMax
      if (this.sortField) {
        const fieldMap = {
          projectName: 'projectName',
          projectLevelDesc: 'projectLevel',
          projectStatusDesc: 'projectStatus',
          labourHour: 'labourHour',
          orderLabourHour: 'orderLabourHour',
          mgmtLabourHour: 'mgmtLabourHour',
          remark: 'remark',
        }
        params.sortField = fieldMap[this.sortField] || this.sortField
        params.sortOrder = this.sortOrder === 'ascending' ? 'asc' : 'desc'
      }
      return params
    },
    buildQueryString(params) {
      return Object.keys(params)
        .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&')
    },
    loadData() {
      const id = this.accountInfo.id
      if (!id) return
      this.tableLoading = true
      const params = this.buildQueryParams()
      params.pageNum = this.currentPage
      params.pageSize = this.pageSize
      let url = `${this.$store.state.islhurl}valued-account/business/${id}/major-project`
      const qs = this.buildQueryString(params)
      if (qs) url += '?' + qs
      this._get(url).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableData = res.data || []
          this.total = res.totalSize || 0
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.query = {
        projectName: '',
        projectLevel: '',
        projectStatus: '',
        labourHourMin: '',
        labourHourMax: '',
        orderLabourHourMin: '',
        orderLabourHourMax: '',
        mgmtLabourHourMin: '',
        mgmtLabourHourMax: '',
      }
      this.sortField = ''
      this.sortOrder = ''
      this.currentPage = 1
      this.loadData()
    },
    handleSortChange({ prop, order }) {
      this.sortField = order ? (prop || '') : ''
      this.sortOrder = order || ''
      this.currentPage = 1
      this.loadData()
    },
    onPageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    onSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadData()
    },
    handleModify(row) {
      this.modifyRow = row
      this.modifyRemark = row.remark || ''
      this.modifyVisible = true
    },
    saveModify() {
      if (!this.modifyRow || !this.modifyRow.projectId) return
      const id = this.accountInfo.id
      if (!id) return
      this.modifySaving = true
      const url = `${this.$store.state.islhurl}valued-account/business/${id}/major-project/${this.modifyRow.projectId}`
      this._put(url, { remark: this.modifyRemark }).then(res => {
        this.modifySaving = false
        if (res.code === 200) {
          this.$message.success('Remark updated successfully!')
          this.modifyVisible = false
          this.loadData()
        } else {
          this.$message.error(res.msg || 'Update failed!')
        }
      }).catch(() => {
        this.modifySaving = false
        this.$message.error('Update failed!')
      })
    },
    handleExport() {
      const id = this.accountInfo.id
      if (!id) return
      this.exportLoading = true
      const params = this.buildQueryParams()
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === null || params[key] === '') delete params[key]
      })
      this.$axios({
        url: `${this.$store.state.islhurl}valued-account/business/${id}/major-project/export`,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        this.exportLoading = false
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        const d = new Date()
        const dateStr = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`
        aEle.download = 'MajorProject_' + dateStr + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.exportLoading = false
        this.$message.error('Export failed!')
      })
    },
    openDetail(row) {
      sessionStorage.setItem('majorProjectDetail', JSON.stringify({
        detailId: row.projectId,
        detailStatus: row.projectStatusDesc,
        companyOrRepresentative: row.projectLevel == 4 ? '2' : '1'
      }));
      sessionStorage.setItem('majorProjectSourceTab', this.$store.state.tabOpen);
      // 保存当前价值客户详情页的返回信息，以便从 majorProject 返回时恢复
      sessionStorage.setItem('valuedAccountReturnInfo', JSON.stringify({
        accountId: this.accountInfo.id,
        activeTab: this.$parent.activeTab || 'majorProject',
      }));
      this.$router.push('/majorProject');
    },
  },
}
</script>

<style lang="less" scoped>
.major-project-tab {
  // Query
  .mp-query {
    padding: 8px 0 5px 0;
    /deep/ .el-col {
      margin-bottom: 7px;
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
      padding: 0 15px 0 0;
    }
    /deep/ .el-form-item__label {
      font-size: 13px;
      color: #1F2937;
      text-align: right;
    }
    /deep/ .el-select {
      width: 100%;
    }
    /deep/ .el-form-item__content .el-input__suffix {
      left: auto;
      right: 10px;
    }
    /deep/ .el-range-editor.el-input__inner {
      width: 100%;
    }
  }
  .mp-range-pair {
    display: flex;
    align-items: center;
    gap: 0;
    .mp-range-sep {
      margin: 0 6px;
      color: #6B7280;
      font-size: 13px;
    }
  }
  .mp-btn-col {
    padding-top: 0;
    text-align: right;
    /deep/ .el-button + .el-button {
      margin-left: 10px;
    }
  }

  // Table Tags
  .mp-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    line-height: 20px;
    &.mp-tag-green { background: #f6ffed; color: #52C41A; border: 1px solid #b7eb8f; }
    &.mp-tag-blue { background: #e6f7ff; color: #1890FF; border: 1px solid #91d5ff; }
    &.mp-tag-orange { background: #fff7e6; color: #FA8C16; border: 1px solid #ffd591; }
    &.mp-tag-red { background: #fff1f0; color: #F5222D; border: 1px solid #ffa39e; }
    &.mp-tag-gray { background: #fafafa; color: #8C8C8C; border: 1px solid #d9d9d9; }
  }

  // Pagination
  .mp-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 0 0;
    gap: 12px;
    .mp-pagination-total {
      font-size: 13px;
      color: #6B7280;
    }
  }
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/MajorProject.vue